import { createAction, props } from '@ngrx/store';

export const saveStartHours = createAction(
    '[AUTH] save start hours',
    props<{ value: any }>(),
);
